import { render, staticRenderFns } from "./card-ticket-grantDetails.vue?vue&type=template&id=9d3057a6&scoped=true&"
import script from "./card-ticket-grantDetails.vue?vue&type=script&lang=js&"
export * from "./card-ticket-grantDetails.vue?vue&type=script&lang=js&"
import style0 from "./card-ticket-grantDetails.vue?vue&type=style&index=0&id=9d3057a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d3057a6",
  null
  
)

export default component.exports